/**
 * Shared utility functions for virtual file explorer operations.
 */

export function isValidItemName(name: string): boolean {
  if (!name || !name.trim()) return false;
  const trimmed = name.trim();
  if (trimmed.includes('/') || trimmed.includes('\\') || trimmed.includes('..')) return false;
  return !/[:*?"<>|\x00-\x1f]/.test(trimmed);
}

export function computeDuplicateCandidate(
  name: string,
  existingNames: string[]
): string {
  const lastDot = name.lastIndexOf('.');
  const baseName = lastDot >= 0 ? name.slice(0, lastDot) : name;
  const ext = lastDot >= 0 ? name.slice(lastDot) : '';

  let candidate = `${baseName}_copy${ext}`;
  let counter = 2;
  const lowerSet = new Set(existingNames.map((n) => n.toLowerCase()));
  while (lowerSet.has(candidate.toLowerCase())) {
    candidate = `${baseName}_copy_${counter}${ext}`;
    counter++;
  }
  return candidate;
}

export function getParentPath(path: string): string {
  const idx = path.lastIndexOf('/');
  return idx >= 0 ? path.slice(0, idx) : '';
}

export function getFileExtension(filePath?: string): string {
  if (!filePath) return '';
  const lastDot = filePath.lastIndexOf('.');
  if (lastDot === -1) return '';
  return filePath.slice(lastDot + 1).toLowerCase();
}

export function matchesAllowedExtensions(filePath?: string, allowedExtensions?: string[]): boolean {
  if (!filePath) return false;
  if (!allowedExtensions || allowedExtensions.length === 0) return true;

  const ext = getFileExtension(filePath);
  const normalizedAllowed = allowedExtensions.map((e) => (e.startsWith('.') ? e.slice(1) : e).toLowerCase());
  return normalizedAllowed.includes(ext);
}

export function normalizeRelativePath(path?: string): string {
  if (!path) return '';
  return path
    .replace(/\\/g, '/')
    .replace(/\/+/g, '/')
    .replace(/^\/+/, '');
}
